// extracted by mini-css-extract-plugin
export var loadingSpinner = "_4i-1";
export var standaloneTable = "_4i-0";